// removed by extract-text-webpack-plugin
module.exports = {"storePage":"AppStoreLinksPage-storePage-13-TI","storePageHeader":"AppStoreLinksPage-storePageHeader-1n-hz","storePageTitle":"AppStoreLinksPage-storePageTitle-35BNY","storeFooterText":"AppStoreLinksPage-storeFooterText-1B2os","storeFooter":"AppStoreLinksPage-storeFooter-1smi8","storeBadges":"AppStoreLinksPage-storeBadges-228K1","storeBadge":"AppStoreLinksPage-storeBadge-2MVmj"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/AppStoreLinksPage.styl
// module id = ./modules/issFrontend/styles/AppStoreLinksPage.styl
// module chunks = 1